module.exports = __webpack_public_path__ + "static/media/video01.5d02d72c.jpg";